import React, { Component } from 'react';
import { browser } from '../../../lib-jitsi-meet';
/**
 * Implements a React/Web {@link Component} for displaying video
 * in order to facilitate cross-platform source code.
 *
 * @augments Component
 */
export default class Video extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            html: "",
        };
    }
    componentDidMount() {
        const src = browser.isSafari() ? "images/macbooksolo.mp4?versionid=223" : "images/macbooksolo.webm?versionid=223";
        const html = `
          <video autoPlay muted loop style="max-width: 100%">
              <source src=${src} />
          </video>
        `;
        //@ts-ignore
        this.setState({ html });
    }
    render() {
        return React.createElement("div", { dangerouslySetInnerHTML: { __html: this.state.html } });
    }
}
